import React from 'react';
import { Box, Typography } from '@mui/material';
import BlueButton from './BlueButton.tsx';
import { Link } from 'react-router-dom';

const BannerHub = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        background: 'linear-gradient(to right, #0f0f0f, #1e1e1e)',
        borderRadius: '20px',
        padding: { xs: '2rem', md: '3rem' },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'visible',
        mx: 5,
        maxWidth: '937px'
      }}
    >
      {/* Etiqueta flotante */}
      <Box
        sx={{
          position: 'absolute',
          top: { xs: 24, md: 24 },
          right: { xs: -26, md: -26 },
          color: 'white',
          borderRadius: '50rem',
          padding: '14px 24px',
          background: 'linear-gradient(25deg,rgba(10, 98, 116, 0.49) 10%,rgba(19, 185, 218, 0.51))',
          letterSpacing: '0.2rem',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
          transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
          fontWeight: 500,
          textDecoration: 'none',
          fontSize: '16px',
          border: 'none',
          zIndex: 1,
          backdropFilter: 'blur(10px)',

          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            padding: '1px',
            borderRadius: '50rem',
            background: 'linear-gradient(180deg, rgb(0,255,255,0.5),rgba(10, 98, 116, 0.55))',
            WebkitMask:
              'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude',
            zIndex: -1,
            transition: 'opacity 0.3s ease',
          },
        }}
      >
        TOTALMENTE GRATUITO
      </Box>

      {/* Contenido izquierdo */}
      <Box sx={{ maxWidth: { xs: '100%', md: '50%' }, pt: { xs: 10, md: 0 } }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: 'white',
            mb: 2,
          }}
        >
          ¿Quieres llevar tu desarrollo al siguiente nivel?
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: 'white', mb: 1 }}
        >
          <b>Explora nuestra sección </b> de recursos de desarrollo y accede a ebooks, herramientas, plantillas, videos y mucho más.
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: 'white', mb: 3 }}
        >
          Todo lo que necesitas para superar desafíos y alcanzar tus metas está aquí. <b>¡Empieza ahora y transforma tu camino!</b>
        </Typography>

        {/* Botones */}
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: { xs: 'space-evenly', sm: 'center', md: 'space-between' } }}>
          <BlueButton component={Link} to="/hub-formativo">
            <Typography component="span" sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
              Visitar Hub Informativo
            </Typography>
          </BlueButton>

          <BlueButton component={Link} to="/hub-formativo" sizevariant="md" variant="icon">
            <img
              src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744825924/ebm/download-icon_al5gur.png"
              alt="icono descarga"
              style={{ width: '20px', height: '20px' }}
            />
          </BlueButton>

        </Box>

        {/* Imagen del hub */}
        <Box
          component="img"
          src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744216085/ebm/hub-image_nyzcgo.png"
          alt="hub recursos"
          sx={{
            maxWidth: { xs: '100%', sm: '70%', md: '48%' },
            marginTop: { xs: '2rem', md: 0 },
            marginLeft: { md: '2rem' },
            position: { xs: 'relative', md: 'absolute' },
            top: { xs: 24, md: 80 },
            right: 0,
          }}
        />
      </Box>
    </Box>
  );
};

export default BannerHub;
